import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { timeout } from 'rxjs/operators';

@Component({
  selector: 'app-backend-offline',
  imports: [],
  templateUrl: './backend-offline.component.html',
  styleUrl: './backend-offline.component.scss',
})
export class BackendOfflineComponent {}
